import React from 'react'
import styled, { withComponent } from 'react-emotion'
import { space } from 'styled-system'
import Link from 'gatsby-link'

import { Box, Text } from '../components/Layout'
import {
  Title,
  Subtitle,
  NarrowParagraph,
  Rule,
} from '../components/Typography'
import { StyledLink } from '../components/StyledLink.js'
import { SocalLinks } from '../components/SocialLinks.js'
import ProjectPreview from '../components/ProjectPreview'

const SectionTitle = Text.withComponent('h2')

const indexPage = ({ data }) => {
  return (
    <article>
      <header>
        <Title
          fontSize={[4, 5]}
          fontWeight="7"
          lineHeight="title"
          mt={0}
          mb={3}
        >
          Hi!
        </Title>
        <Subtitle fontSize={[3, 4]} fontWeight="5" lineHeight="title" my={3}>
          I&rsquo;m Lukas&nbsp;Pustina.
        </Subtitle>
        <NarrowParagraph fontSize={[2, 3]} lineHeight="copy" mt={3} mb={4}>
          I&rsquo;m Chief Information Officer (CIO) and board member at{' '}
          <StyledLink
            to="https://scopevisio.com"
            text="Scopevisio"
            external={true}
          />{' '}
          as well as Managing Director at{' '}
          <StyledLink
            to="https://centerdevice.de"
            text="CenterDevice"
            external={true}
          />
          , where we develop cutting-edge cloud-based software services for
          enterprises. I&rsquo;m currently living in Germany.
        </NarrowParagraph>
        <NarrowParagraph fontSize={[2, 3]} lineHeight="copy" mt={3} mb={4}>
          I&rsquo;ve enjoyed developing software and building infrastructure for
          almost 25&nbsp;years and plan to keep doing so for much longer. In
          those 25&nbsp;years, many things have changed drastically. Other
          things have stayed very much the same. I&rsquo;ve seen new things
          become old and old things become new again. In a way, there's always
          something new and something old to learn.
        </NarrowParagraph>
        <NarrowParagraph fontSize={[2, 3]} lineHeight="copy" mt={3} mb={4}>
          Here you can read my <StyledLink to="/notes/" text="Notes" />
          {' and '}
          <StyledLink to="/publications/" text="Publications" /> about what
          I&rsquo;ve learned, about my{' '}
          <StyledLink to="/projects/" text="Projects" />, and{' '}
          <StyledLink to="/about/" text="About" /> me. If you like to talk,
          you&rsquo;ll find me on <SocalLinks />.
        </NarrowParagraph>
      </header>
      <main />
    </article>
  )
}

export default indexPage



// WEBPACK FOOTER //
// ./src/pages/index.js